import { useCallback, useState } from "react";
import globalConfig from '../config/globalConfig.json'



// import AuthContext from "../store/auth/auth-context";

const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [message, setMessage] = useState("");

  const sendRequest = useCallback(async (requestInfo: any, applyData: any) => {

    setIsLoading(true);
    setIsError(false);

    try {
      const respose = await fetch(globalConfig.SERVER_HOST+requestInfo.URL, {
        method: requestInfo.method ? requestInfo.method : "GET",
        headers: requestInfo.header ? requestInfo.header : {},
        body: requestInfo.body ? JSON.stringify(requestInfo.body) : null,
        credentials: 'include'
      });


      if (!respose.ok && respose.status!=401) {
        throw new Error("Request Faild!!");
      }
      const data = await respose.json();
      if (data.error) setIsError(data.error);
      if (data.message) setMessage(data.message);

      // if (data.isAuthError)
      //   setIsAuthError(true)

      applyData(data);
      
    } catch (err: any) {
      setIsError(true);
      setMessage("Somthing went wrong");
    }
    setIsLoading(false);
  }, []);


  // console.log(sendRequest,message)

  return {
    isLoading,
    isError,
    // isAuthError,
    message,
    sendRequest,
  };
};

export default useHttp;

// import:
// call: const {isLoading, isError, sendRequest: FetchUsers} = useHttp()
